import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { createTheme, ThemeProvider } from "@mui/material";
import { loadRuntimeConfig } from "./lib/runtime-config";
import { claimChunkReload } from "./lib/chunk-reload";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0F6DFA",
      light: "#E2EDFE",
    },
    error: {
      main: "#D24141",
      light: "#FDF2F2",
    },
    warning: {
      main: "#FFBF0F",
      light: "#FFE8A8",
    },
    success: {
      main: "#1A8474",
      light: "#E6F9F6",
    },
  },
  // override font family
  typography: {
    fontFamily: "Outfit, sans-serif",
  },
});

window.addEventListener("vite:preloadError", (event) => {
  if (!claimChunkReload(window.sessionStorage, Date.now())) {
    return;
  }
  event.preventDefault();
  window.location.reload();
});

const root = ReactDOM.createRoot(document.getElementById("root"));

function renderBootError(message) {
  root.render(<p style={{ fontFamily: "sans-serif", padding: 24 }}>{message}</p>);
}

async function bootstrap() {
  try {
    await loadRuntimeConfig();
  } catch (error) {
    console.error(error);
    renderBootError("Failed to load application configuration. Please refresh the page or contact support.");
    return;
  }

  let App;
  try {
    ({ default: App } = await import("./App"));
  } catch (error) {
    console.error(error);
    renderBootError("Failed to load the application. Please refresh the page or contact support.");
    return;
  }
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </React.StrictMode>
  );
}

bootstrap();
